import { createContext } from "react";


const Contextor = createContext(); 

export default Contextor;